import { type ReactNode } from 'react';
import { WaitlistForm } from './WaitlistForm';

type SplashHeroProps = {
  subtitle?: ReactNode;
};

export function SplashHero({ subtitle }: SplashHeroProps) {
  return (
    <section
      className="relative flex flex-col items-center justify-center min-h-screen px-4 py-24 overflow-hidden"
      aria-labelledby="hero-headline"
    >
      <div
        className="absolute inset-0 animate-gradient"
        style={{
          background: [
            'radial-gradient(ellipse at 20% 50%, hsl(190 37% 57% / 0.18) 0%, transparent 60%)',
            'radial-gradient(ellipse at 80% 20%, hsl(220 60% 40% / 0.14) 0%, transparent 55%)',
            'radial-gradient(ellipse at 60% 80%, hsl(190 37% 30% / 0.12) 0%, transparent 50%)',
            'hsl(var(--background))',
          ].join(', '),
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 flex flex-col items-center text-center max-w-3xl mx-auto">
        <div className="mb-10">
          <picture>
            <source
              srcSet="/logo_white.png"
              media="(prefers-color-scheme: dark)"
            />
            <img
              src="/logo.png"
              alt="Open1031"
              className="h-14 md:h-20 w-auto"
            />
          </picture>
        </div>

        <h1
          id="hero-headline"
          className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-tight mb-6 animate-slide-up"
        >
          The first AI-powered
          <br />
          <span className="text-primary">1031 exchange</span> platform
        </h1>

        <p className="text-lg sm:text-xl text-muted-foreground mb-12 max-w-xl animate-fade-in">
          {subtitle ?? 'Coming soon. Be first to know when we launch.'}
        </p>

        <WaitlistForm />
      </div>
    </section>
  );
}
